import axios from "axios";
import { postLogout } from "../../Api/Api";

import Cookies from "universal-cookie";
import AppCache from "../Common/AppCache";
import PermissionService from "../../Services/PermissionService";
const cookies = new Cookies();

function Logout(callTheAPI, handleNavigate) {
  if (callTheAPI) {
    axios({
      method: "POST",
      url: postLogout(),
    }).then((res) => {
      if (res.status === 200) {
        // window.location.reload();
        cookies.remove("name", { path: "/" });
        cookies.remove("sessionId", { path: "/" });
        cookies.remove("access_token", { path: "/" });

        // to be removed after all user's cookies have been cleared
        cookies.remove("pages", { path: "/" });
        cookies.remove("pagesMeta", { path: "/" });
        cookies.remove("navigationCard", { path: "/" });
        cookies.remove("locationFilter", { path: "/" });
        cookies.remove("orgFilter", { path: "/" });

        AppCache.removeItem("pages");
        AppCache.removeItem("pagesMeta");
        AppCache.removeItem("navigationCard");
        AppCache.removeItem("permissions");
        cookies.remove("orgName", { path: "/" });
        cookies.remove("amplitudeID", { path: "/" });
        cookies.remove("timeZone", { path: "/" });
        cookies.remove("isAutomaticTimezone", { path: "/" });
        cookies.remove("fleetID", { path: "/" });
        localStorage.removeItem("LocationFilter");
        localStorage.removeItem("OrgFilter", { path: "/" });

        // NEW: Clear RBAC permissions
        localStorage.removeItem("rbac_permissions");
        localStorage.removeItem("rbac_version");
        localStorage.removeItem("rbac_enabled");
        AppCache.removeItem("rbacVersion");
        AppCache.removeItem("rbacEnabled");
        PermissionService.clearPermissions();
        console.log('[Logout] RBAC permissions cleared');


        handleNavigate();
        // window.location.reload();
      }
    });
  } else {
    cookies.remove("name", { path: "/" });
    cookies.remove("sessionId", { path: "/" });
    cookies.remove("access_token", { path: "/" });

    // to be removed after all user's cookies have been cleared
    cookies.remove("pages", { path: "/" });
    cookies.remove("pagesMeta", { path: "/" });
    cookies.remove("navigationCard", { path: "/" });
    cookies.remove("locationFilter", { path: "/" });
    cookies.remove("orgFilter", { path: "/" });

    AppCache.removeItem("pages");
    AppCache.removeItem("pagesMeta");
    AppCache.removeItem("navigationCard");
    AppCache.removeItem("permissions");
    cookies.remove("orgName", { path: "/" });
    cookies.remove("amplitudeID", { path: "/" });
    cookies.remove("timeZone", { path: "/" });
    cookies.remove("isAutomaticTimezone", { path: "/" });
    cookies.remove("fleetID", { path: "/" });
    localStorage.removeItem("LocationFilter");
    localStorage.removeItem("OrgFilter", { path: "/" });

    // NEW: Clear RBAC permissions
    localStorage.removeItem("rbac_permissions");
    localStorage.removeItem("rbac_version");
    localStorage.removeItem("rbac_enabled");
    AppCache.removeItem("rbacVersion");
    AppCache.removeItem("rbacEnabled");
    PermissionService.clearPermissions();
    console.log('[Logout] RBAC permissions cleared');

    AppCache.clearOnLogout();
    window.location.reload();
  }
}

export default Logout;
